import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CContainer,
	CForm,CFormInput,CInputGroup,CInputGroupText,//CFormSelect,CFormCheck,CFormTextarea,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
	CBadge,
	CSpinner,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
//import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
	MyDialogpasien,
	MyCardformpasien,
} from '../components/index'
import { Konfirm } from '../helpers/onConfirm'
import { UFunc } from '../helpers/functions'

const pjson 	= require('../../package.json')
const Terapijenis	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uConfigappsObj			= useSelector(state => state.uConfigappsObj) || {}; 
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 25) : 100;
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uISDemoapp				= uConfigappsObj.level_app === "DEMO";
	const uISHapusallow				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN") ? true : false;
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction);
	const uHandelView 				= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 			= uHeaderActionObj.isHeaderTambah || false;

	//--VIEWS_VARS--/
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uRowselect,setRowselect]		= React.useState(-1);
	//const [uIDselect,setIDselect]		= React.useState(0);//--TIDAK_DIPAKAI--/
	const [uFirsload,setFirsload]		= React.useState("YA");
	//--END VIEWS_VARS--/

	//--INIT_SELECTED_BEFORE--/->PAGINATION_BY_BACKEND--
	const uLastinitObj 					= useSelector(state => state.gInitTabelSelected);// || {};
	const [uInitselectedObj,setInitselectedObj] = React.useState({});
	//--END INIT_SELECTED_BEFORE--/

	//--DLGFORM--/
	const [uISDlgformshow,setDlgformshow]		= React.useState(false);
	const [uDlgformdataObj,setDlgformdataObj]	= React.useState({});
	//--END DLGFORM--/

	//--DLGVIEW--/
	//--END DLGVIEW--/

	//--DOM_VARS--/
	const uElJmlData			= document.getElementById("idjmldata");
	//--END DOM_VARS--/

	//--HANDEL--/
	const hdlKlikEdit = (_IDTABEL) => {
		_IDTABEL 		= parseInt(_IDTABEL);

		const vArridx 	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		const vIdxRow	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL)
		setRowselect(vIdxRow);

		setDlgformdataObj({
			dlg_header:"Edit: "+UFunc.Usercaptionfilter(uDatamainArr[vArridx].nama_terapi,4).toUpperCase(),
			nama_terapi: uDatamainArr[vArridx].nama_terapi,
			tabel_id: _IDTABEL,
			poin_perawat: parseInt(uDatamainArr[vArridx].poin_perawat)||0,
		});
		setDlgformshow(true);
	}
	const hdlKlikHapus = async(_IDTABEL) => {
		const vArridx		= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL)
		const vCaptionupper	= (uDatamainArr[vArridx].nama_terapi || "").toUpperCase();

		if(await Konfirm(
			"<p>Terapi: <b>"+vCaptionupper+"</b> Akan DIHAPUS.."+
			"<br/><small class='fst-italic'>Proses Hapus Tidak Dapat Diulangi dan Dibatalkan.</small>"+
			"</p>"+
			"<p class=''>Apakah Anda Yakin ?</p>"+
			"")) apiProseshapus(_IDTABEL);
	}
	const hdlKlikDlgsimpan = () => {
		//--VALIDASI--/
		let vElFocus = document.getElementById("inpformterapinama");
		if((uDlgformdataObj.nama_terapi||"").trim() === "") {
			vElFocus && vElFocus.focus();
			showToast("Nama Jenis Terapi Harus Diisi !"); return;
		}
		if((uDlgformdataObj.nama_terapi||"").length < 3) {
			vElFocus && vElFocus.focus();
			showToast("Nama Jenis Terapi Tidak Valid (Min.3 Karakter) !"); return;
		}
		//--END VALIDASI--/

		apiProsessimpan();
	}
	//--END HANDEL--/

	//--INIT_FUNC--/
	//--END INIT_FUNC--/

	//--CONTENT_FUNC--/
	const contentMain = () => {
		if(uHtml500msg) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= vMin;
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_terapijenis || "");
		const vKeywordcolor = uSettingObj.color_keyword || "#D725FF";
		const vReplace 		= new RegExp(vKeyword,"ig");

		const vTglnow		= UFunc.DbDate();
		//--PAGINATION_BY_FRONTEND--*/
		const vDataviewArr	= isMobile 
			? uDatamainArr.slice(0,vMax) : uDatamainArr.slice(vMin,vMax);
		//--END PAGINATION_BY_FRONTEND--*/
		/*//--PAGINATION_BY_BACKEND--/
		const vDataviewArr	= uDatamainArr.filter(vItems => 
			parseInt(vItems.page||1) === parseInt(uPageActive));
		//--END PAGINATION_BY_BACKEND--*/
		
		return (
		<div className="px-lg-5 mx-md-5">
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width={35} className="px-1"><small>No</small></th>
			<th className="px-0">
			<CRow className="mx-0">
			<CCol md="8" className="text-start px-1"><small>{uBahasaObj.caption_namajenisterapi||"Nama Jenis Terapi"}</small></CCol>
			<CCol md="2" className="px-1"><small>Poin Perawat</small></CCol>
			<CCol md="2" className="px-1">&middot;</CCol>
			</CRow>
			</th>
			</tr>

			<tr className="d-md-none classfontsmaller">
				<th width={30} className="p-0"/>
				<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys) => {
			const {
				id,nama_terapi,tgl_input,user_input,poin_perawat,
			} = vItems;

			vNumber++;
			const vCaptionupper	= (nama_terapi||"").toUpperCase();

			const vTerapinama	= vKeyword==="" ? (nama_terapi||"UNDF NAMA") 
				: (nama_terapi||"UNDF NAMA").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vUserinput	= vKeyword==="" ? UFunc.Usercaptionfilter(user_input||"").toUpperCase() 
				: UFunc.Usercaptionfilter(user_input||"").replace(vReplace,"<b><u style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");

			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uRowselect===vKeys?" classrowselect":"")}>
				<td className="px-1 pe-0"><big>{vNumber}.</big></td>

				<td className="px-1 px-md-0">
				<CRow className="mx-0">
				<CCol md="8" className="px-1 text-start">
					<div className="d-flex justify-content-between">
						<div className="text-info pe-1 d-md-none">{UFunc.renderHTML(vTerapinama)}</div>
						<big className="text-info d-none d-md-block">{UFunc.renderHTML(vTerapinama)}</big>

						{(uISHapusallow) && (
						<CDropdown className="d-md-none">
							<CDropdownToggle caret={false} size="sm"
								className="p-0" 
								color="transparent">
								<CIcon icon="cilOptions" height={18}/>
							</CDropdownToggle>
							<CDropdownMenu>
								<CDropdownItem onClick={()=>hdlKlikEdit(id)}>
									<CIcon className="classikonedit align-middle me-2" height={25}/>
									Edit Jenis Terapi
								</CDropdownItem>

								<CDropdownDivider/>

								<CDropdownItem onClick={()=>hdlKlikHapus(id)}>
									<CIcon className="classikonhapus align-middle me-2" height={25}/>
									Hapus Jenis Terapi
								</CDropdownItem>
							</CDropdownMenu>
						</CDropdown>
						)}
					</div>

					<div className="text-danger classfontsmaller d-none d-md-block">
						<small>[
						{UFunc.WaktuAngka(tgl_input)}
						<span className="mx-1">&middot;</span>
						{UFunc.renderHTML(vUserinput)}
						]</small>
					</div>
				</CCol>

				<CCol xs="12" className="px-1 d-md-none classborderbottom my-3"/>

				<CCol xs="6" className="px-1 text-start d-md-none">Poin Perawat</CCol>
				<CCol xs="6" md="2" className="px-1 text-md-center">
					{UFunc.formatAngka(poin_perawat)} <span className="d-md-none">POIN</span>
				</CCol>

				<CCol md="2" className="px-1 d-none d-md-block text-md-center">
					{uISHapusallow ? (
					<>
					<CTooltip className="d-none d-lg-block" content={"--Edit: "+vCaptionupper}>
					<CLink onClick={()=>hdlKlikEdit(id)} className="classcursorpointer classikontabel classikonedit"/>
					</CTooltip>

					<CTooltip className="d-none d-lg-block" content={"--Hapus: "+vCaptionupper}>
					<CLink onClick={()=>hdlKlikHapus(id)} className="classcursorpointer classikontabel classikonhapus"/>
					</CTooltip>
					</>
					) : (<>&middot;</>)}
				</CCol>

				<CCol xs="12" className="px-1 d-md-none classborderbottom my-3"/>

				<CCol xs="4" className="px-1 text-start d-md-none text-danger classfontsmaller">Input by</CCol>
				<CCol xs="8" className="px-1 d-md-none text-danger classfontsmaller">
					<small>[
					{UFunc.WaktuAngka(tgl_input)}
					<span className="mx-1">&middot;</span>
					{UFunc.renderHTML(vUserinput)}
					]</small>
				</CCol>
				</CRow>
				</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		</div>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		return (
		<CForm className="mx-lg-5">
		<CRow className="my-2">
		<CCol xs="4" className="">Nama Jenis Terapi</CCol>
		<CCol className="">
			<CFormInput size="sm" maxLength={100}
				value={uDlgformdataObj.nama_terapi}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,nama_terapi:e.target.value})}
				id="inpformterapinama"/>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4" className="">Poin Perawat</CCol>
		<CCol md="4" lg="3" className="">
			<CInputGroup size="sm">
			<CFormInput size="sm" type="number"
				min={0}
				className="text-end"
				onFocus={(e)=>e.target.select()}
				value={uDlgformdataObj.poin_perawat||0}
				onChange={(e)=>setDlgformdataObj({...uDlgformdataObj,poin_perawat:e.target.value})}
				onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
				id="inpformpoinperawat"/>
			<CInputGroupText>POIN</CInputGroupText>
			</CInputGroup>
		</CCol>
		</CRow>
		</CForm>
		)//>
	}
	//--END CONTENT_FUNC--/

	//--API--/
	const apiLoaddata = (_PAGE) => {
		_PAGE			= parseInt(_PAGE)||1;
		const vKeyword 	= uKeywordObj.kwd_terapijenis || "";
		setHtml500msg();

		//--PAGINATION_BY_FRONTEND--/
		setJmlData(0);
		setDatamainArr([]);
		setRowselect(-1);
		setPageActive(1);
		//--END PAGINATION_BY_FRONTEND--*/

		/*//--PAGINATION_BY_BACKEND--/
		let vDatamainArr	= uDatamainArr;
		if(vKeyword.length < 3) {
			vDatamainArr 	= []
		} else {
			if(uDatamainArr.length >= 10000) {
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.page||1) === 1);
			} else
				vDatamainArr	= vDatamainArr.filter(vItems=>parseInt(vItems.page||1) !== uPageActive);
		}
		//--END PAGINATION_BY_BACKEND--*/
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_keyword : vKeyword,
			send_firsload: uFirsload,
			/*//--PAGINATION_BY_BACKEND--/
			send_page: _PAGE,
			send_jmlperpage: uMaxData,
			send_loadjml: (JSON.stringify(uLastinitObj||{}) !== "{}") ? "YA" : "TIDAK",
			//--END PAGINATION_BY_BACKEND--*/
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapijenis/ld_data";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				const vTmpArr = JSON.parse(output_string.dataobject||"[]");

				//--PAGINATION_BY_FRONTEND--/
				setDatamainArr([...vTmpArr]);
				//--END PAGINATION_BY_FRONTEND--*/

				/*//--PAGINATION_BY_BACKEND--/
				vTmpArr.forEach(vItems=>vItems.page = _PAGE);
				setDatamainArr([...vDatamainArr,...vTmpArr]);
				setJmlData(parseInt(output_string.total_data||uJmlData))

		    	if(JSON.stringify(uLastinitObj||{}) !== "{}")
		    		setInitselectedObj(uLastinitObj);
				//--END PAGINATION_BY_BACKEND--*/

				setFirsload("YA");

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Pasien - apiLoaddata) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Pasien - apiLoaddata) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProsessimpan = () => {
		const vElsbutton= document.getElementById("btnDialogSimpan");
		vElsbutton && (vElsbutton.disabled = true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapi - apiProsessimpan) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vTabelid	= parseInt(uDlgformdataObj.tabel_id)||0;
		const vDATAS	= JSON.stringify({
			send_parsobj: JSON.stringify({...uDlgformdataObj,
				dlg_header: undefined,
			}),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapijenis/pr_simpan";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			vElsbutton && (vElsbutton.disabled = false);
			if(output_string.sukses) {
				let vTmpObj = {...(uDlgformdataObj),
					id: vTabelid,
					dlg_header: undefined,
					tabel_id: undefined,
				}

				if(vTabelid <= 0) {
					const vTabelidnew	= parseInt(output_string.tabelidnew||"255");
					vTmpObj 			= {...vTmpObj, 
						id: vTabelidnew,
						tgl_input: UFunc.DbDatetime(),
						user_input: uTokenObj.usercaption,
					}
					setDatamainArr([vTmpObj,...uDatamainArr]);

					showToast((uBahasaObj.pesan_sukses || "Data Berhasil Disimpan.."),"SUKSES");
					setDlgformdataObj({
						...uDlgformdataObj,
						nama_terapi: "",
					});

					const vElFocus = document.getElementById("inpformterapinama");
					if(!isMobile) vElFocus && vElFocus.focus();
				} else {
					const vArridx	= UFunc.getObjectIndeks(uDatamainArr,vTabelid);
					uDatamainArr[vArridx] = {
						...(uDatamainArr[vArridx]||{}),
						...vTmpObj,
					}
					setDlgformshow(false);
				}
			} if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapi - apiProsessimpan) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vElsbutton && (vElsbutton.disabled = false);
			setLoading(false);
			console.log("(Terapi - apiProsessimpan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProseshapus = (_IDTABEL) => {
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		console.log("(Terapi - apiProsessimpan) LEWaT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vTabelid	= parseInt(_IDTABEL)||0;
		const vDATAS	= JSON.stringify({
			send_tabelid: vTabelid,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_terapijenis/pr_hapus";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200){setSessionaktif(false);return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				const vArridx	= UFunc.getObjectIndeks(uDatamainArr,vTabelid);
				uDatamainArr.splice(vArridx,1);
				setEfekview(!uEfekview);
			} if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Terapi - apiProsessimpan) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Terapi - apiProsessimpan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

		//--PAGINATION_BY_FRONTEND--/
		apiLoaddata();
		//--END PAGINATION_BY_FRONTEND--*/

		/*//--PAGINATION_BY_BACKEND--/
		if(JSON.stringify(uLastinitObj||{}) !== "{}") {
			setPageActive(uLastinitObj.initPage||1);
			apiLoaddata(uLastinitObj.initPage||1);
		}
		//--END PAGINATION_BY_BACKEND--*/

    	return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
    		setDatamainArr([]);setFirsload("YA");
    		setInitselectedObj({});
			setDlgformshow(false);
    	}
	},[])
	//--PAGINATION_BY_FRONTEND--/
	React.useEffect(()=>{
		setJmlData(uDatamainArr.length);
	},[uDatamainArr.length])
	//--END PAGINATION_BY_FRONTEND--*/
	React.useEffect(()=>{ 
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/

		/*//--PAGINATION_BY_BACKEND--/
		const vKeyword 		= uKeywordObj.kwd_terapijenis || "";
		if(vKeyword.length < 3) {
			uElJmlData && (uElJmlData.innerHTML = "&#8734;");
			return;
		}
		//--END PAGINATION_BY_BACKEND--*/

		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
	},[uElJmlData,uJmlData])
	React.useEffect(()=>{ 
		//--PAGINATION_BY_FRONTEND--/
		setRowselect(-1);
		//--END PAGINATION_BY_FRONTEND--*/

		/*//--PAGINATION_BY_BACKEND--/
    	if(JSON.stringify(uLastinitObj||{}) !== "{}") return;
    	if(uPageActive <= 0) { setPageActive(1); return }

		setRowselect(-1); 
		const vDataviewArr	= uDatamainArr.filter(vItems=>parseInt(vItems.page||1) === parseInt(uPageActive));
		if(vDataviewArr.length > 0) {
			window.scrollTo({ top: 0, behavior: "smooth" });
			return;
		}
		apiLoaddata(uPageActive);
		//--END PAGINATION_BY_BACKEND--*/
	},[uPageActive]);
	React.useEffect(()=>{
		if(!uHandelView) return;

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		//--PAGINATION_BY_FRONTEND--/
		setDatamainArr([]);
		setJmlData(0);
		setRowselect(-1);
		setPageActive(1);
		//--END PAGINATION_BY_FRONTEND--*/

		/*//--PAGINATION_BY_BACKEND--/
		if(parseInt(uPageActive) !== 1) {
			setPageActive(1);
			return;
		} 
		//--END PAGINATION_BY_BACKEND--*/

		apiLoaddata();
	},[uHandelView])
	React.useEffect(()=>{
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) return;

		setRowselect(-1);
		setDlgformdataObj({
			dlg_header:"Tambah Jenis Terapi",
			nama_terapi: "",
			poin_perawat: 0,
		});
		setDlgformshow(true);
	},[uHandelTambah])
	React.useEffect(()=>{
		if(!uISDlgformshow) {
			setDlgformdataObj({}); return;
		}

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);

			const vElfocus	= document.getElementById("inpformterapinama");
			if(!isMobile) vElfocus && vElfocus.focus();
		},300);
	},[uISDlgformshow])

	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHtml500msg)  return (
		<CCard className="classbgcard">
		<CCardHeader>
		<strong>{uBahasaObj.caption_page500||"Page 500"}</strong>
		</CCardHeader>
		<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
		</CCard>
	)

	return (
		<>
		<CCard className="classbgcard">
		<CCardHeader className="d-flex justify-content-between align-items-center">
		<div>
		<b className="align-middle">{uBahasaObj.caption_listdata||"List Data"}</b>
		<span className="mx-1 d-md-none">&middot;</span>
		<small className="d-md-none text-primary align-middle">{(()=>{
			const vKeyword = (uKeywordObj.kwd_pasien||"").trim();
			if(vKeyword.length < 3) return (<>&#8734;</>);

			return (<>[{UFunc.formatAngka(uJmlData)}]</>)
		})()}</small>
		</div>
		<span className="text-muted classfontsmaller">
			<small>{UFunc.formatAngka(uTimeelapse)}ms</small>
		</span>
		<small className="d-none">({uJmlData} - {uMaxData})</small>
		</CCardHeader>
		
		<CCardBody className="px-0 px-md-3">{contentMain()}</CCardBody>

		{(uJmlData > uMaxData) && (
		<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/> 
		</CCardFooter>
		)}
		</CCard>

		<MyDialogform
			options={{size:"lg",centered:true}}
			onSimpan={()=>hdlKlikDlgsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgformdataObj.dlg_header}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>
		</>
	)//>
}	

export default Terapijenis